import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-square-two",
  "use": "icon-square-two-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" fill=\"\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-square-two\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1 1H1.5H13.5H14V1.5V13.5V14H13.5H1.5H1V13.5V1.5V1ZM2 2V13H13V2H2Z\" fill=\"\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol